import React, { useState, useEffect } from "react";
import '../HomePage/HomeInsurance.css';
import FormArea from "../HomePage/FormArea";
import homeLowestRate from "../Images/home-lowest-rate.png";
import DigitLogo from "../Images/digit-logo.png";
import GoogleReview from "../Images/google-review.png";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { apiURL, baseUrl } from "../index";
import { CentralCall } from "../CommonMethods/CentralCall";
import { useSharedDataContext } from "../components/SharedDataContext";

const HomeInsurance = () => {
    const [isActive, setIsActive] = useState(false);
    const [BtnValue, setBtnValue] = useState("View Quotes");
   
    const history = useHistory();
    const { sharedData, setSharedData } = useSharedDataContext();
    const onSubmit = (data) => {

        EnquiryNumber(data);
    }

    const findUserID = async () => {
        let user = 0;
        if (window.localStorage.getItem("token")) {
            await axios.post("https://crmapi.smcinsurance.com:8081/api/User/GetUserInfo", {
                Token: JSON.parse(window.localStorage.getItem("token")).token
            })
                .then((res) => {
                    user = res.data.userID
                });
        }
        return user;
    }

    const EnquiryNumber = async(data) => {

        const userID = await findUserID();
        const EnquiryReq = {
            "BusinessID": window.localStorage.getItem("BusinessID"),
            "UserId": userID,
            "MobileNo": data.mobileNo
        }
        console.log({ EnquiryReq });
        const Model = {
            URL: `${apiURL}api/Enquiry/GenerateEnquiry`,
            Req: EnquiryReq,
            IsPost: true
        }
        CentralCall(Model)
            .then(Res => {
                if (Res.data.statusCode === 200) {

                    const FormData = {
                        policyTerm:"1",
                        propertyType: data.property,
                        pincode: data.pincode,
                        mobileNo: data.mobileNo,
                        insure: data.insure,
                        enquiryRes: Res.data.response,
                        enquiry: Res.data.response.enquiryNo,
                        insurerList: Res.data.response.insurers,
                        buildingComponent: { areaOfBuilding: data.areaOfBuilding, valueOfBuilding: data.valueOfBuilding, valueOfHouseHoldItem: data.valueOfHouseHoldItem },
                        descriptionOfOccupancy: data.occupancyID
                    }
                    setSharedData(prev => ({ ...prev, QuotePageDetails: FormData }));
                    history.push({
                        pathname: "/quotes",
                        state: {
                            Req: FormData
                        }
                    });
                } else setBtnValue("View Quotes");
            }).catch(reject => {
                setIsActive(false);
                setBtnValue("View Quotes");
                console.log(reject.message)
            });
    }

 
    return (
        <>
            <div className="HomePageMain">
                <div className="container">
                    <div className="LowestRatePage">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="Lowest_Rate2">
                                    <h2><span className="green-text">Comprehensive </span> Home Protection with Home Insurance </h2>
                                    <p>We suggest best plans as per your requirements</p>
                                    <h4>Plan starting @ <span className="green-text">₹ 13/month</span><sup>*</sup></h4>
                                    <div className="LowerRate_img">
                                        <img src={homeLowestRate} alt="Home Insurance at Lowest Rates" />
                                        <img src={DigitLogo} alt="Home Insurance at Lowest Rates" className="digit_logo" />
                                    </div>
                                    <div className="LowerRate_img2">
                                        <img src={GoogleReview} alt="Home Insurance at Lowest Rates" />
                                    </div>
                                </div>
                                <div className="condition_apply"><p><i><sup>* </sup> Conditions Applied</i></p></div>
                            </div>
                            <div className="col-lg-6">
                                <div className="form_boxHome">
                                    <FormArea FormHeading="Please Enter Your Details" onSubmitDetails={onSubmit} BtnValue={BtnValue} term="By clicking here, I state that I have read and understood the terms and conditions." TandC="T&C" />
                                </div>
                            </div>
                            {/*<div className="col-lg-4">
                                <div className="Lowest_Rate">
                                    <div className="LowerRate_img">
                                        <img src={lowestRateHome1} alt="Home Insurance at Lowest Rates" />
                                    </div>
                                </div>
                            </div>*/}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default HomeInsurance;